import { createUseStyles } from 'react-jss';
import { WrenchTheme } from '@wds/styles';

const useStyles = createUseStyles(
  ({
    spacing,
    borderRadius,
    bgColor,
    semanticColor,
    breakpoints,
  }: typeof WrenchTheme) => ({
    wrapper: {
      textAlign: 'center',
      backgroundColor: bgColor.bg,
      display: 'flex',
      justifyContent: 'center',
      padding: [150, 0],
    },

    messageWrapper: {
      minWidth: 550,
      margin: 0,
      position: 'unset',
    },

    messageContainer: {
      padding: spacing[6],
      backgroundColor: bgColor.light,
      border: [1, 'solid', semanticColor.muted],
      borderRadius: borderRadius.small,
      marginTop: spacing[4],
    },

    linksContainer: {
      position: 'relative',
      margin: spacing[4],
      overflow: 'hidden',
    },

    linksList: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      marginLeft: -1,
      listStyleType: 'none',
    },

    linksListItem: {
      flexGrow: 1,
      flexBasis: 'auto',
      textAlign: 'center',
      borderRight: [1, 'solid', '#ccc'],
      backgroundColor: bgColor.light,

      '&:last-child': {
        borderRight: 'none',
      },
    },

    errorPage: {
      textAlign: 'center',
    },

    errorLogo: {
      position: 'fixed',
      top: spacing[5],
      left: spacing[5],
      margin: 0,
      width: 200,
      height: 30,

      [`@media (max-width: ${breakpoints.sm})`]: {
        position: 'relative',
        display: 'block',
        top: 0,
        left: 0,
        backgroundColor: bgColor.bg,
      },
    },
  })
);

export default useStyles;
